import type { LiveWorkerLocationDto } from '../../../types/access'

export function liveWorkerProfileId(worker: LiveWorkerLocationDto) {
  return worker.globalWorkerProfileId || worker.global_worker_profile_id || worker.workerProfileId || worker.worker_profile_id || ''
}

export function reconcileSelectedLiveWorker(currentId: string, workers: LiveWorkerLocationDto[]) {
  if (!currentId) return { selectedWorkerId: '', disappeared: false }
  const remainsVisible = workers.some((worker) => liveWorkerProfileId(worker) === currentId)
  return { selectedWorkerId: remainsVisible ? currentId : '', disappeared: !remainsVisible }
}

export function liveWorkerInitials(displayName?: string | null) {
  const parts = (displayName || 'Worker').trim().split(/\s+/).filter(Boolean)
  return (parts.length > 1 ? `${parts[0][0]}${parts[parts.length - 1][0]}` : parts[0]?.slice(0, 2) || 'W').toUpperCase()
}

export function shouldReconcileLocationAccess(accessibleCount: number, relationshipCount: number) {
  return accessibleCount > 0 || relationshipCount > 0
}
